import { useState, Fragment, useContext, useEffect } from 'react';
import { useGet } from '@/query/fetchHooks';
import {
  InputText,
  ContentCard,
  Button,
  IconButton,
  FilterList,
  TEOLoader,
  Tag as ComponentTag,
  FilterButton,
  ProgressBar,
  Tag,
} from '@teo/components';
import {
  Search,
  ChevronDown,
  ChevronUp,
  DuoToneTrajectoryFilled,
  ChapterFilled,
  TimeFilled,
  Eye,
} from '@teo/components/icons';
import { T } from '@/components/T';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';
import { useNavigate } from 'react-router-dom';
import { PaginationAnythingNew } from '@/components/DataTable/PaginationAnythingNew';
import { HintsContext } from '@/components/Contexts/HintsContext';
import Hint from '@/components/Hints/Hints';
import { NavContext } from '@/components/NavContext';
import { useMobile } from '@/util';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';
import { format } from 'date-fns';

export interface Filter {
  label: string;
  value: string;
}

const LearnCourseOverview = ({
  courseType,
  title,
}: {
  courseType: string;
  title: string;
}) => {
  const { t } = useTranslation();
  const { hints } = useContext(HintsContext);
  const { setSubPage, setLeftSidebarToggle } = useContext(NavContext);
  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 250);
    return () => clearTimeout(t);
  }, [filter]);
  const [sort, setSort] = useState([{ id: 'createdAt', desc: true }]);
  const [loadCourses, setLoadCourses] = useState<any>(true);

  const [tab, setTab] = useState('active');
  const [filterStatus, setFilterStatus] = useState(courseType);
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;
  const isMobile = useMobile();
  const coursePath = window.location.pathname;
  const [loadCounter, setLoadCounter] = useState(false);

  const [counterContent, setCounterContent] = useState({
    active: null,
    new: null,
    done: null,
    all: null,
  });

  useEffect(() => {
    setLeftSidebarToggle(true);
    return () => setLeftSidebarToggle(false);
  });

  useGet(`/mycourses`, {
    scope: 'nothidden',
    userId: authUser?.id,
    organisationId: authUser?.activeOrganisationId + ',OR,organisationId=null',
    courseType: courseType,
    learningpathId: 'null',
    onSuccess: (result: any) => {
      const active = result?.data?.filter(
        (el: any) =>
          (el?.status == 'active' || el?.status == 'pending') &&
          el?.courseStatus == 'active'
      );
      const newC = result?.data?.filter(
        (el: any) =>
          (el?.status == 'pending' || el?.status == null) &&
          el?.courseStatus == 'active'
      );
      const done = result?.data?.filter(
        (el: any) =>
          el?.status == 'done' ||
          el?.status == 'pendingcorrection' ||
          el?.status == 'ended' ||
          el?.courseStatus == 'disabled'
      );
      setCounterContent({
        active: active?.length,
        new: newC?.length,
        done: done?.length,
        all: result?.data?.length,
      });
      setLoadCounter(true);
    },
  });

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  function statusCourseObj(str: string) {
    switch (str) {
      case 'active':
        return {
          value: 'status=active,OR,status=pending',
          courseStatus: 'courseStatus=active',
        };
      case 'new':
        return {
          value: 'status=pending,OR,status=null',
          courseStatus: 'courseStatus=active',
        };
      case 'done':
        return {
          value: 'status=done,OR,status=pendingcorrection,OR,status=ended',
          courseStatus: 'courseStatus=disabled',
        };
      default:
        return null;
    }
  }

  useEffect(() => {
    if (tab != 'all') {
      const selectFilter = statusCourseObj(tab);
      setFilterStatus(
        tab != 'done'
          ? `${courseType}&${selectFilter?.courseStatus}&${selectFilter?.value}`
          : `${courseType}&${selectFilter?.courseStatus},OR,${selectFilter?.value}`
      );
    } else {
      setFilterStatus(courseType);
    }
  }, [tab]);

  function convertToTime(number: number) {
    const hours = Math.floor(number / 3600);
    const minutes = Math.round((number / 3600 - hours) * 60);
    return (
      hours +
      `${t('pages.learn_index.hour')} ` +
      minutes +
      `${t('pages.learn_index.minute')} `
    );
  }

  const createMarkup = (text: any) => {
    if (text) return { __html: text };
  };

  // if (courseType === 'instruction' && FILTERS) {
  //   FILTERS.pop();
  // }

  return (
    <div className="mx-auto w-full max-w-[700px]">
      {isMobile ? (
        <MobileSubPageMenu title={title} />
      ) : (
        <div className="my-6">
          <h1 className="text-xl font-semibold text-black">
            <T>{title}</T>
          </h1>
        </div>
      )}
      <Fragment>
        {/* <div
          className={`md:w-2/2 relative mb-8 sm:w-2/3 ${
            hints?.id == `hint_09` && 'active-hint-parent !z-[100]'
          }`}
        >
          <InputText
            value={filter}
            onChange={(ev) => setFilter(ev.target.value)}
            Icon={Search}
            placeholder={t('search.course')}
          />
        </div> */}
        <div className="mb-8 flex flex-col justify-between gap-2.5 md:flex-row md:gap-0 lg:flex-row lg:gap-0">
          <div
            className={`relative flex items-center ${
              hints?.id == `hint_08` && 'active-hint-parent'
            }`}
          >
            <Hint
              key={`hint_08`}
              id={`hint_08`}
              leftDots={'-left-2 top-[9px]'}
              title={t(`hint.title_08`)}
              order={8}
              style={{
                left: '-10px',
                top: '65px',
              }}
            />
            {loadCounter && (
              <div className={`relative flex flex-wrap items-center gap-2`}>
                <FilterButton
                  active={tab === 'active'}
                  onClick={() => {
                    if (tab != 'active') {
                      setTab('active');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.active')}
                    <span
                      className={`text-sm  ${
                        tab === 'active' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.active ? counterContent?.active : 0}
                    </span>
                  </p>
                </FilterButton>

                <FilterButton
                  active={tab === 'new'}
                  onClick={() => {
                    if (tab != 'new') {
                      setTab('new');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.new')}
                    <span
                      className={`text-sm  ${
                        tab === 'new' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.new ? counterContent?.new : 0}
                    </span>
                  </p>
                </FilterButton>

                <FilterButton
                  active={tab === 'done'}
                  onClick={() => {
                    if (tab != 'done') {
                      setTab('done');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.completed')}
                    <span
                      className={`text-sm  ${
                        tab === 'done' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.done ? counterContent?.done : 0}
                    </span>
                  </p>
                </FilterButton>
                <FilterButton
                  active={tab === 'all'}
                  onClick={() => {
                    if (tab != 'all') {
                      setTab('all');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.all')}
                    <span
                      className={`text-sm  ${
                        tab === 'all' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.all ? counterContent?.all : 0}
                    </span>
                  </p>
                </FilterButton>
              </div>
            )}
          </div>
        </div>
        {loadCourses && (
          <div className="mx-auto flex justify-center py-20 px-10">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[100px]"
            />
          </div>
        )}
        <PaginationAnythingNew
          className={`mt-3 flex w-full flex-col gap-10 ${
            loadCourses === true && ' hidden '
          }`}
          fetch={useGet.bind(null, '/mycourses', {
            scope: 'nothidden',
            userId: authUser?.id,
            organisationId:
              authUser?.activeOrganisationId + ',OR,organisationId=null',
            courseType: filterStatus,
            learningpathId: 'null',
            onSuccess: (result: any) => {
              setLoadCourses(false);
            },
          })}
          empty={{
            template: 2,
            loadContent: loadCourses,
            text: t('empty_tenplate.course_list'),
          }}
          defaultSort={sort}
          page={0}
          pageSize={10}
          filter={debouncedFilter}
          tab={tab}
          render={(course: any) => (
            <div
              className="group flex w-full cursor-pointer flex-col gap-6 sm:flex-row"
              onClick={() => navigate(`${coursePath}/${course.id}`)}
            >
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={
                    course?.courseImage ||
                    course?.image ||
                    '/assets/images/opleidingen.jpg'
                  }
                  alt={course?.courseName || course?.name || ''}
                  className="h-[144px] w-full rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105 sm:w-[224px]"
                />
                <div className="absolute top-1 left-2 ">
                  <Tag
                    title={
                      course?.courseStatus == 'disabled'
                        ? t('status.disabled')
                        : t(`status.${course.status}`, course.status as string)
                    }
                    variant={
                      course?.status == 'done' ||
                      course?.status == 'pendingcorrection' ||
                      course?.status == 'ended' ||
                      course?.courseStatus == 'disabled'
                        ? 'error'
                        : 'primary'
                    }
                  />
                </div>
                <div className="absolute inset-0 h-full w-full rounded-lg transition-transform duration-500 group-hover:scale-105 group-hover:backdrop-blur-sm"></div>
                <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                  <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                    <Eye className="h-5 w-5 "></Eye>
                  </span>
                </span>
                <div className="absolute top-0">
                  <img
                    key={course.id}
                    src={`/images/flags/${course.lang}.svg`}
                    alt="courseImage"
                    className="
                          mt-2
                          ml-2
                          hidden
                          h-[25px] w-[25px]
                          rounded-[50%]
                          bg-tint-red
                          object-cover
                          group-hover:block
                          "
                  />
                </div>
              </div>
              <div className="flex flex-1 flex-col gap-2">
                <div className="flex flex-col gap-1">
                  <h3 className="text-base-semibold whitespace-break-spaces mb-2 !mb-0 break-keep text-left text-grey-08">
                    {course?.courseName || course?.name || ''}
                  </h3>
                  {course?.courseEndDate &&
                  course?.courseType !== 'instruction' ? (
                    <p className="text-sm font-normal text-grey-05">
                      {`${t('pages.learn_index.last_open')}` +
                        format(new Date(course?.courseEndDate), 'dd/MM')}
                    </p>
                  ) : (
                    ''
                  )}
                </div>

                {course?.courseType !== 'instruction' && course.progress ? (
                  <div className="flex items-center">
                    <ProgressBar
                      max={100}
                      value={
                        course?.progress
                          ? Math.round(course?.progress * 100)
                          : 0
                      }
                      className={`r-progress-bar h-1 rounded-lg ${
                        course?.progress * 100 > 99 && 'progress-bar__all'
                      }`}
                    />
                    <span className="ml-3 text-xs text-grey-06">
                      {course.progress ? Math.round(course.progress * 100) : 0}
                      &#37;
                    </span>
                  </div>
                ) : (
                  ''
                )}
                {(course?.description || course?.courseDescription) && (
                  <div
                    className="break-words text-left text-sm font-normal text-grey-08 line-clamp-3"
                    dangerouslySetInnerHTML={createMarkup(
                      course?.courseDescription || course?.description || ''
                    )}
                  />
                )}

                <div className="flex flex-row gap-4">
                  {course?.nrOfLessons > 0 && (
                    <div className="flex items-center">
                      <ChapterFilled className="h-4 w-4 text-grey-04" />
                      <p className="pl-1 text-sm text-grey-05">
                        {course?.nrOfLessons}
                      </p>
                    </div>
                  )}

                  {course?.totalEstimatedTime ? (
                    <div className="flex items-center">
                      <TimeFilled className="h-4 w-4 text-grey-04" />
                      <p className="pl-1 text-sm text-grey-05">
                        {convertToTime(Math.abs(course?.totalEstimatedTime))}
                      </p>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          )}
        />
      </Fragment>
    </div>
  );
};

export default LearnCourseOverview;
